import { SxProps, Theme } from '@mui/material';

export const BoldTextAttrSx: SxProps = {
	display: 'inline',
	alignItems: 'center',
	color: '#2C2C2C',
	marginTop: '0rem',
	fontWeight: 'bold',
	letterSpacing: '0',
	fontSize: 'var(--font-size-small)',
};

export const tileDescriptionSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	display: 'inline',
	fontSize: 'var(--font-size-small)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: 'normal',
	opacity: 1,
	marginLeft: '3px',
};

export const titleSelectSizeSx: SxProps = {
	display: 'inline',
	alignItems: 'center',
	color: '#2C2C2C',
	marginTop: '0rem',
	fontWeight: 'bold',
	letterSpacing: '0',
	fontSize: 'var(--font-size-default)',
};

export const valueSelectSizeSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	display: 'inline',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: 'normal',
	opacity: 1,
	marginLeft: '3px',
};

export const linkTitleSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	display: 'inline',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: 'primary.main',
	fontWeight: 'normal',
	opacity: 1,
	textDecoration: 'none',
	marginLeft: '6px',
	'&:hover': {
		textDecoration: 'none',
	},
};
export const noMargin: SxProps = {
	fontSize: 'var(--font-size-small)',
	textDecoration: 'none',
	margin: '0 1px 0 3px',
	fontWeight: 'normal',
	position: 'relative',
	bottom: '1px',
	'&:hover': {
		textDecoration: 'none',
	},
};
export const tileDescription2SX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	display: 'inline',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: 'normal',
	opacity: 1,
};
